import React from 'react'

import {ImageProvider as ImageProviderType} from '@daedalus/core/src/staticContent/types/ImageProvider'

export const ImageContext = React.createContext<ImageProviderType | undefined>(
  undefined
)

export const ImageProvider = ImageContext.Provider
